<template>
  <div class="login-container">
    <!-- 左侧装饰区域 -->
    <div class="decoration-area">
      <div class="illustration">
        <!-- 旋转齿轮图标装饰 -->
        <div class="gear-icon gear-1"><i class="el-icon-setting"></i></div>
        <div class="gear-icon gear-2"><i class="el-icon-setting"></i></div>
      </div>
    </div>

    <!-- 右侧登录表单 -->
    <div class="login-form-container">
      <div class="login-form">
        <div class="logo-area">
          <div class="logo">
            <img src="@/assets/img/logo.png" alt="Logo" />
          </div>
          <div class="system-name">管理员登录</div>
        </div>
        <!-- 登录表单 -->
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="form"
        >
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              prefix-icon="el-icon-user"
              placeholder="用户名"
            ></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              prefix-icon="el-icon-lock"
              type="password"
              placeholder="密码"
              @keyup.enter.native="handleLogin"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            class="login-button"
            :loading="loading"
            @click="handleLogin"
            >立即登录</el-button
          >
        </el-form>
      </div>
    </div>
    <!-- 验证码对话框 -->
    <el-dialog
      title="安全验证"
      :visible.sync="captchaVisible"
      width="360px"
      :close-on-click-modal="false"
      :show-close="false"
      center
    >
      <div class="captcha-container">
        <p class="captcha-tip">请输入图片中的验证码</p>
        <div class="captcha-image" @click="refreshCaptcha">
          <img :src="captchaImage" alt="验证码" />
          <div class="refresh-tip">点击刷新</div>
        </div>
        <el-input
          v-model="captchaInput"
          placeholder="请输入验证码"
          class="captcha-input"
          maxlength="4"
        ></el-input>
        <div class="captcha-actions">
          <el-button @click="captchaVisible = false">取消</el-button>
          <el-button type="primary" @click="verifyCaptcha" :loading="verifying">
            确定
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import { setToken } from "@/utils/auth";
import { pwdLogin } from "@/api";
export default {
  name: "Login",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不能少于6位"));
      } else {
        callback();
      }
    };

    return {
      // 登录表单数据
      loginForm: {
        username: "",
        password: "",
      },
      // 表单验证规则
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },
      loading: false,
      // 验证码相关数据
      captchaVisible: false, // 验证码对话框是否可见
      captchaImage: "", // 验证码图片URL
      captchaInput: "", // 用户输入的验证码
      captchaText: "", // 正确的验证码文本
      verifying: false, // 验证中状态
    };
  },
  methods: {
    // 处理登录按钮点击事件
    handleLogin() {
      // 表单验证
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // 显示验证码对话框
          this.showCaptcha();
        } else {
          return false; // 表单验证失败
        }
      });
    },
    // 显示验证码对话框
    showCaptcha() {
      this.captchaVisible = true;
      this.captchaInput = "";
      this.refreshCaptcha();
    },

    // 刷新验证码
    refreshCaptcha() {
      // 生成随机验证码文本
      this.captchaText = this.generateCaptchaText(4);
      // 生成验证码图片
      this.generateCaptchaImage(this.captchaText);
    },

    // 生成随机验证码文本
    generateCaptchaText(length) {
      const characters =
        "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789";
      let result = "";
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
      }
      return result;
    },

    // 生成验证码图片
    generateCaptchaImage(text) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = 120;
      canvas.height = 40;

      // 绘制背景
      ctx.fillStyle = "#f0f0f0";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 绘制干扰线
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = this.getRandomColor(150, 200);
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.stroke();
      }

      // 绘制干扰点
      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = this.getRandomColor(150, 200);
        ctx.beginPath();
        ctx.arc(
          Math.random() * canvas.width,
          Math.random() * canvas.height,
          1,
          0,
          2 * Math.PI
        );
        ctx.fill();
      }

      // 绘制文本
      ctx.font = "bold 24px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      // 每个字符使用不同颜色和角度
      for (let i = 0; i < text.length; i++) {
        ctx.fillStyle = this.getRandomColor(0, 100);
        ctx.save();
        ctx.translate(30 + i * 20, 20);
        ctx.rotate((Math.random() - 0.5) * 0.3);
        ctx.fillText(text[i], 0, 0);
        ctx.restore();
      }

      // 转换为图片URL
      this.captchaImage = canvas.toDataURL("image/png");
    },

    // 生成随机颜色
    getRandomColor(min, max) {
      const r = Math.floor(Math.random() * (max - min) + min);
      const g = Math.floor(Math.random() * (max - min) + min);
      const b = Math.floor(Math.random() * (max - min) + min);
      return `rgb(${r},${g},${b})`;
    },

    // 验证用户输入的验证码
    verifyCaptcha() {
      this.verifying = true;

      // 验证码不区分大小写
      if (this.captchaInput.toLowerCase() === this.captchaText.toLowerCase()) {
        // 验证码正确，执行登录
        this.doLogin();
      } else {
        // 验证码错误，刷新验证码
        this.$message.error("验证码错误，请重新输入");
        this.refreshCaptcha();
        this.captchaInput = "";
        this.verifying = false;
      }
    },
    // 执行登录操作
    doLogin() {
      this.loading = true;
      // 调用密码登录API
      pwdLogin({
        phone: this.loginForm.username, // 用户名（手机号）
        pwd: this.loginForm.password, // 密码
        user_type: 1, // 用户类型：1表示管理员
      })
        .then((res) => {
          this.verifying = false;
          this.captchaVisible = false;

          if (res.status == 200) {
            this.loading = false; // 隐藏加载状态
            // 显示登录成功消息
            this.$message({
              message: "登录成功",
              type: "success",
            });
            // 保存登录状态和令牌到本地存储
            setToken("isAdminAuth", true); // 设置管理员认证状态
            setToken("access_token", res.data.token); // 保存访问令牌
            setToken("phone", res.data.phone); // 保存用户手机号
            // 跳转到管理后台首页
            this.$router.push({ path: "/admin/center" });
          } else {
            this.loading = false; // 隐藏加载状态
            // 显示登录失败消息
            this.$message({
              message: "登录失败,请重新登录",
              type: "error",
            });
          }
        })
        .catch(() => {
          this.verifying = false;
          this.captchaVisible = false;
          this.loading = false;
          this.$message.error("登录请求失败，请稍后重试");
        });
    },
  },
};
</script>
  
  <style scoped>
.login-container {
  display: flex;
  padding: 0 300px;
  height: 100vh;
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(
    135deg,
    rgba(230, 255, 240, 0.6),
    rgba(255, 230, 220, 0.6)
  );
  overflow: hidden;
}

.decoration-area {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.illustration {
  width: 80%;
  max-width: 500px;
  position: relative;
}

.illustration img {
  width: 100%;
}

.gear-icon {
  position: absolute;
  color: #2196f3;
  font-size: 40px;
  animation: rotate 10s linear infinite;
}

.gear-1 {
  top: 10%;
  left: 10%;
}

.gear-2 {
  top: 20%;
  left: 30%;
}

.plant {
  position: absolute;
  bottom: 10%;
  left: 15%;
  width: 80px;
}

.plant img {
  width: 100%;
}

.login-form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 450px;
}

.login-form {
  width: 350px;
  padding: 30px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.logo-area {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.logo {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.system-name {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.form {
  margin-top: 20px;
}

.login-button {
  width: 100%;
  padding: 12px 0;
  font-size: 16px;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 验证码容器样式 */
.captcha-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
}

/* 验证码提示文字 */
.captcha-tip {
  margin-bottom: 15px;
  color: #606266;
  font-size: 14px;
}

/* 验证码图片容器 */
.captcha-image {
  width: 120px;
  height: 40px;
  margin-bottom: 15px;
  cursor: pointer;
  position: relative;
  border: 1px solid #dcdfe6;
  overflow: hidden;
  transition: all 0.3s;
}

.captcha-image:hover {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
}

/* 验证码图片 */
.captcha-image img {
  width: 100%;
  height: 100%;
  display: block;
}

/* 刷新提示 */
.refresh-tip {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 12px;
  text-align: center;
  padding: 2px 0;
  opacity: 0;
  transition: opacity 0.3s;
}

.captcha-image:hover .refresh-tip {
  opacity: 1;
}

/* 验证码输入框 */
.captcha-input {
  width: 200px;
  margin-bottom: 20px;
}

/* 验证码操作按钮 */
.captcha-actions {
  display: flex;
  justify-content: space-between;
  width: 200px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }

  .decoration-area {
    display: none;
  }

  .login-form-container {
    width: 100%;
  }
}
</style>